import React, { Component } from 'react';
import classnames from 'classnames';
import './TextInput.css';

const defaultProps = {
  type: 'text',
  onChange: () => {},
  autoFocus: false,
};

class TextInput extends Component {
  get value() {
    return this.input.value;
  }

  set value(value) {
    this.input.value = value;
  }

  getInputDOM() {
    return this.input;
  }

  handleClear = () => {
    this.input.value = '';
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.props.onChange({
      preventDefault: () => {},
      target: this.input,
      currentTarget: this.input,
    });
  };

  render() {
    return (
      <div className={classnames(this.props.className, 'Input--textNew')}>
        <input
          {...this.props}
          className="Input-input"
          ref={(c) => (this.input = c)}
          type={this.props.type}
        />
      </div>
    );
  }
}

TextInput.defaultProps = defaultProps;

export default TextInput;
